'use strict'

/**
 * Controller class for next stepper.
 *
 * @class NextStepperController
 */
class NextStepperController {
  constructor($attrs, elementService) {
    'ngInject'

    this._$attrs = $attrs
    this._elementService = elementService
  }

  $postLink() {
    const modifiers = this._elementService.getComponentAttrs(
      this._$attrs,
      'modifier'
    )
    modifiers &&
      modifiers.forEach(modifier => {
        this._$attrs.$addClass(`vd-next-stepper--${modifier}`)
      })

    this._$attrs.$addClass('vd-next-stepper')
  }

  showDott() {
    return this._$attrs.dott
  }

  toggleStepDetails() {
    this.reveal = !this.reveal
  }
}

NextStepperController.$inject = ['$attrs', 'elementService']

export default NextStepperController
